/* eslint-disable */
import React from 'react';
import { Box } from '../../components/element';
import { GenericSelect } from '../../components/select';
import { getQueryStringValues } from '../../utils/withPath';
import { getOptInfo } from '../../config/productsConfig';
import queryString from 'query-string';
export default function StoragePurchaseSelector(props) {
  const {
    location,
    history,
    product,
    modelQueryStringKey = 'model',
    storagePurchaseQueryStringKey = 'storagepurchaseopt',
  } = props;
  const queryStringValues = getQueryStringValues(props.location);
  const storagePurchaseOpt = queryStringValues[storagePurchaseQueryStringKey];
  const model = queryStringValues[modelQueryStringKey];
  const { selectBoxLabelForStoragePurchase, optionsForStoragePurchase, selectedOptValueForStoragePurchase } = getOptInfo({ productId: product });
  const onStoragePurchaseOptChange = value => {
    let newValues = { product: product, storagepurchaseopt: value.value, model: model };
    if (storagePurchaseOpt !== undefined && value.value !== storagePurchaseOpt ) {
      newValues = { product: product, storagepurchaseopt: value.value };
    }
    history.replace({
      pathname: location.path,
      search: queryString.stringify(newValues),
    });
  };
  if (product === 'baas' && optionsForStoragePurchase.length === 0) {
    return null;
  }
  if (product === 'oaas' && optionsForStoragePurchase.length === 0) {
    return null;
  }

  return (
    <>
      <Box width="medium" data-test-id="select-storage-purchase" className="paddingBottom6">
        <GenericSelect
          id="storage-purchase-selector"
          label={selectBoxLabelForStoragePurchase}
          value={storagePurchaseOpt}
          onChange={onStoragePurchaseOptChange}
          errorMessage={props.PurchaseErrMsg}
          options={optionsForStoragePurchase}
        />
      </Box>
    </>
  );
}
